// extracted by mini-css-extract-plugin
export default {"container":"Contratacion_container__QUEkG","img-container":"Contratacion_img-container__DSIoF"};